import $ from 'jquery';

const $menu = $('.top-menu'),
    $menu_wrapper = $('.top-menu-wrapper'),
    $menu_switcher = $('#id_mobile_menu'),
    $ul = $menu_wrapper.children('ul'),
    resizeMenu = () => {
        $('li', $menu).off('mouseover');
        $('li', $menu).off('mouseleave');
        $ul.children('li').children('ul').hide();

        if ($(window).width() > 991) {
            $menu_wrapper.show();
            $ul.children('li').mouseover(function (e) {
                e.preventDefault();
                $(this).children('ul').fadeIn(10);
            });
            $ul.children('li').mouseleave(function (e) {
                e.preventDefault();
                $(this).children('ul').fadeOut(10);
            });
        } else {
            $menu_wrapper.hide();
            $ul.children('li').off('click');
            $('> li', $ul).click(function (e) {
                e.preventDefault();
                if ($(this).children('ul').is(':visible')) {
                    window.location.href = $('a', this).attr('href');
                } else {
                    $ul.children('li').children('ul').slideUp();
                    $(this).children('ul').slideToggle();
                }
            }).find('li').click(function(e){
                e.stopPropagation();
            });
        }
    };


if ($menu.length) {
    $menu_switcher.click(function (e) {
        e.preventDefault();
        $ul.children('li').children('ul').hide();
        $menu_wrapper.slideToggle();
    });
    resizeMenu();
    $(window).resize(() => resizeMenu());
}



// WEBPACK FOOTER //
// ./js/common/menu.js